import * as React from 'react';

import PvXMark from './PvXMark';
import useStyleSheet from './useStyleSheet';

type CssVarStyle = React.CSSProperties & Record<string, string | number>;

const CASCADE_STYLES = `
    @keyframes pvx-cascade {
      0%   { opacity: 0; transform: translateY(8px); }
      15%  { opacity: 1; transform: translateY(0); }
      70%  { opacity: 1; transform: translateY(0); }
      100% { opacity: 0; transform: translateY(-6px); }
    }
    .pvx-cascade path { opacity: 0; animation: pvx-cascade var(--pvx-dur) ease-in-out infinite; }
    .pvx-cascade path[data-block="a"] { animation-delay: calc(var(--pvx-dur) * 0.00); }
    .pvx-cascade path[data-block="b"] { animation-delay: calc(var(--pvx-dur) * 0.10); }
    .pvx-cascade path[data-block="c"] { animation-delay: calc(var(--pvx-dur) * 0.20); }
    .pvx-cascade path[data-block="d"] { animation-delay: calc(var(--pvx-dur) * 0.30); }
`;

export type CascadeLoaderProps = {
  size?: number;
};

export const CascadeLoader: React.FC<CascadeLoaderProps> = React.memo(({ size = 140 }) => {
  useStyleSheet(CASCADE_STYLES, 'pvx-css-cascade');

  const dur = 2.2;

  return (
    <PvXMark
      size={size}
      className="pvx-cascade"
      style={{ '--pvx-dur': `${dur}s` } as CssVarStyle}
      role="status"
      aria-label="Loading"
    />
  );
});

export default CascadeLoader;
